<template>
  <div class="eaAreaSurvey">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>
        物业区域概况
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container">
      <div class="box">
        <div class="AreaSurvey">
          <div class="title">{{areaProtoy.title}}</div>
          <div class="info">
            <div class="col">
              <div class="text">物业区域总数</div>
              <div class="num" @click="forwordtoarea">{{areaProtoy.areaCount}}</div>
            </div>
            <div class="col">
              <div class="text">物业服务面积</div>
              <div class="num">
                {{(areaProtoy.dimensionsSum/10000).toFixed(2)}}
                <span class="company">万m²</span>
              </div>
            </div>
            <div class="col">
              <div class="text">业委会总数</div>
              <div class="num">{{areaProtoy.ownerTeamCount}}</div>
            </div>
            <div class="col">
              <div class="text">引进物业企业小区数</div>
              <div class="num" @click="forwordtoarea">{{areaProtoy.reaCount}}</div>
            </div>
          </div>
          <div class="charts">
            <div ref="generalMeeting" style="width:230px;height:230px"></div>
            <div ref="eaarea" style="width:230px;height:230px"></div>
          </div>
        </div>
        <div class="line"></div>
        <div class="AreaSurvey">
          <div class="title">安全生产情况</div>
          <div class="info">
            <div class="col">
              <div class="text">设备总数</div>
              <div class="num" @click="forword">26</div>
            </div>
            <div class="col">
              <div class="text">本月巡检小区数</div>
              <div class="num">6621</div>
            </div>
            <div class="col">
              <div class="text">巡检超期小区数</div>
              <div class="num warn">2</div>
            </div>
            <div class="col">
              <div class="text">本月维保小区数</div>
              <div class="num">62</div>
            </div>
            <div class="col">
              <div class="text">维保超期小区数</div>
              <div class="num warn">2</div>
            </div>
          </div>
          <div class="charts" v-if="!myprop">
            <div>
              <div ref="complainTol" style="width:230px;height:160px"></div>
              <div class="typeTitle">
                <div>
                  <span class="fontSize">已处理</span>
                  <span class="num" @click="forwordtorecord">17</span>
                </div>
                <div>
                  <span class="fontSize">未处理</span>
                  <span class="num" @click="forwordtorecord">4</span>
                </div>
                <div>
                  <span class="fontSize">超时</span>
                  <span class="num warn" @click="forwordtorecord">0</span>
                </div>
              </div>
            </div>
            <div>
              <div ref="degree" style="width:230px;height:160px"></div>
              <div class="typeTitle">
                <div>
                  <span class="fontSize">满意</span>
                  <span class="num" @click="forwordtorecord">17</span>
                </div>
                <div>
                  <span class="fontSize">不满意</span>
                  <span class="num warn" @click="forwordtorecord">4</span>
                </div>
                <div>
                  <span class="fontSize">满意度</span>
                  <span class="num" @click="forwordtorecord">0</span>
                </div>
              </div>
            </div>
          </div>
          <div class="compared" v-if="myprop">
            <div class="chartBox">
              <div class="title">4月投诉同比分析</div>
              <div class="tableInfo ub ub-pj">
                <div>
                  2018年4月全市投诉数：
                  <span class="num">285</span>
                </div>
                <div style="padding-right:20px;">
                  2019年4月全市投诉数：
                  <span class="num">262</span>
                </div>
              </div>
              <div class="infoChart ub">
                <div ref="brokenLine" class="ub-f1" style="height:135px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeControllerSvr } from '@/service/HomeControllerSvr';
import { mapState } from 'vuex';

export default {
  components: {},
  props: { myprop: Boolean },
  data() {
    return {
      areaProtoy: {}
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.HomeControllerSvr = new HomeControllerSvr();
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.HomeControllerSvr.GetEaAreaGenSit(this.token).then(res => {
        this.areaProtoy = res;
        // this.$nextTick(() => {
        const arr1 = [this.areaProtoy.areaCount, this.areaProtoy.ownerCount];
        const arr2 = [this.areaProtoy.areaCount, this.areaProtoy.reaCount];
        this.drawVote(this.$refs.generalMeeting, '成立业委会的小区', arr1);
        this.drawVote(this.$refs.eaarea, '引进物业企业的小区', arr2, '#ffb11a');
        if (!this.myprop) {
          this.drawVote(this.$refs.complainTol, '投诉总数', '', true);
          this.drawVote(this.$refs.degree, '处理满意度', '', true);
        } else {
          this.drawbroken(this.$refs.brokenLine);
        }
      });
      // });
    },
    forwordtorecord() {
      this.$router.push({ path: 'recordMge' });
    },
    forword() {
      this.$router.push({ path: 'equAdministration' });
    },
    forwordtoarea() {
      this.$router.push({
        path: 'queryPropertyArea',
        query: {
          option: 2
        }
      });
    },
    jumpMore() {
      this.$router.push({ path: 'queryPropertyArea' });
    },
    drawVote(dom, name, data, color, option) {
      //投诉统计
      let myChartSatisfaction = this.$echarts.init(dom);
      // let partNum = 0;
      // info.CandidateItems._Items.forEach(item => {
      //   partNum += 1;
      // });
      //let percentage = Math.round(partNum / totlNum * 100) + '%';
      let percentage =
        (parseInt(data[1]) / parseInt(data[0]) * 100).toFixed(0) + '%';
      myChartSatisfaction.setOption({
        // tooltip: {
        //   trigger: 'item',
        //   formatter: '{a} <br/>{b}: {c} ({d}%)'
        // },
        graphic: {
          elements: [
            {
              type: 'text',
              left: 'center',
              top: option ? '70px' : '78px',
              z: 2,
              zlevel: 100,
              style: {
                text: percentage,
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '22px "MicrosoftYaHei", sans-serif'
              }
            },
            {
              type: 'text',
              left: 'center',
              top: option ? '93px' : '175px',
              z: 2,
              zlevel: 100,
              style: {
                text: name,
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '14px "MicrosoftYaHei", sans-serif'
              }
            }
          ]
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['45px', '50px'],
            avoidLabelOverlap: false,
            center: ['50%', '85px'],
            hoverAnimation: false,
            color: [color || '#0f77f2', '#e2e2e2'],
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '15',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: data[1], name: '' },
              { value: data[0] - data[1], name: '' }
            ]
          }
        ]
      });
    },
    drawbroken(dom) {
      let myChartSatisfaction = this.$echarts.init(dom);
      myChartSatisfaction.setOption({
        title: {
          text: '     (单位：件数)',
          textStyle: {
            fontStyle: '16px "MicrosoftYaHei", sans-serif '
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['2018年4月', '2019年4月'],
          x: '200px'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '28px',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['蓝山', '龙华', '坪山', '罗湖', '福田', '盐田', '其他']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '2018年4月',
            type: 'line',
            stack: '总量',
            data: [22, 21, 10, 12, 5, 18, 35]
          },
          {
            name: '2019年4月',
            type: 'line',
            stack: '总量',
            data: [20, 40, 35, 25, 11, 2, 45]
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.eaAreaSurvey {
  background: #fff;
  .container {
    height: 310px;
    .box {
      width: 100%;
      height: 100%;
      padding: 10px;
      display: flex;
      overflow: hidden;
      justify-content: space-between;
      .AreaSurvey {
        flex: 0 1 50%;
        // border-right: 1px solid #eee;
        min-width: 460px;
        max-width: 660px;
        padding: 0 10px 10px 0;
        .title {
          position: relative;
          padding-left: 15px;
          font-size: 14px;
          &::after {
            position: absolute;
            left: 8px;
            top: 2px;
            content: '';
            width: 4px;
            height: 10px;
            background: #0f77f2;
          }
        }
        .info {
          margin-top: 14px;
          margin-bottom: 14px;
          display: flex;
          justify-content: space-around;
          .col {
            flex: 0 1 auto;
            border-right: 1px solid #e2e2e2;
            text-align: center;
            padding: 0 6px;
            .text {
              font-size: 12px;
              line-height: 14px;
            }
            .num {
              font-size: 22px;
              font-weight: bold;
              color: #0f77f2;
              line-height: 36px;
              cursor: pointer;
              &.warn {
                color: #ff4546;
              }
              .company {
                font-size: 14px;
                color: #000;
              }
            }
          }
        }
        .charts {
          display: flex;
          justify-content: space-around;
          .typeTitle {
            margin-top: 16px;
            display: flex;
            flex-direction: row;
            min-width: 200px;
            justify-content: space-around;
            .fontSize {
              display: block;
              height: 14px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: -1px;
              color: #333333;
            }
            .num {
              margin-top: 6px;
              display: block;
              text-align: center;
              &.warn {
                color: #ff4546;
              }
            }
          }
        }
        .compared {
          height: 230px;
          padding: 10px;
          .chartBox {
            // border-top: 1px solid #e2e2e2;
            padding-top: 10px;
            .tableInfo {
              // margin-top: 12px;
              padding: 12px 15px;
              font-size: 12px;
              color: #333;
              .num {
                font-weight: bold;
              }
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 100%;
        background: #e2e2e2;
      }
    }
  }
}
</style>